// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b4f43217","226":"c6bc8f76","245":"241b376b","446":"b5f45a4b","668":"5dcbf191","712":"90e807cd","835":"e729efca","950":"4c60a664","958":"51162eaa"}[chunkId] + ".chunk.js";
};